export default __webpack_public_path__ + "static/media/bg_flipped.d682583e.svg";